import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Layout from './Components/Layout';
import Home from './Pages/Home';
import Login from './Pages/Login';
import ErrorPage from './Pages/ErrorPage';
import Sign from './Pages/Sign';
import Add_test from './Pages/Add.test';
import TestInfo from './Pages/TestInfo';
import TryTest from './Pages/TryTest';
import DuplicateTest from './Pages/DuplicateTest';
import EditTest from './Pages/EditTest';
import Template from './Pages/Template';
import TestReport from './Pages/TestReport';
import { Typography, Box, CircularProgress } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useJwt } from "react-jwt";
import { login,logout } from "./Redux/authSlice";
import { add_test } from "./Redux/testSlice";
import TakeTest from "./Pages/TakeTest";
import TrainTest from "./Pages/TrainTest";
import CreateTrain from "./Pages/CreateTrain";
import PartDetail from "./Pages/PartDetail";
import TestDetail from "./Pages/testDetail";
import CreateTemplate from "./Pages/CreateTemplate";
import TemplateInfo from "./Pages/TemplateInfo";
import DuplicateTemplate from "./Pages/DuplicateTemplate";
import AddParticipant from "./Pages/AddParticipant";
import AssessmentInfo from "./Pages/AssessmentInfo";
import EditTemplate from "./Pages/EditTemplate";
import TryAssessment from "./Pages/TryAssessment";
import TakeAssessment from "./Pages/TakeAssessment";
import AssessmentReport from "./Pages/AssessmentReport";
import Jobs from "./Pages/Jobs";
import AddJob from "./Pages/AddJob";
import JobInfo from "./Pages/JobInfo";
import JobTest from "./Pages/JobTest";
import JobApplication from "./Pages/JobApplication";
import JobReport from "./Pages/JobReport";
import UserProfile from "./Pages/UserProfile";
import MyTests from "./Pages/MyTests";
import MyJobs from "./Pages/MyJobs";
import Verify from "./Pages/Verify";
import EditJob from "./Pages/EditJob";
import Job from "./Pages/Job";
import SendMail from "./Pages/SendMail";
import TakeOpenTest from "./Pages/TakeOpenTest";
import CandidateDetail from "./Pages/CandidateDetail";
import CandidatePortal from "./Pages/CandidatePortal";
import CandidateTestPortal from "./Pages/CandidateTestPortal";

const AppRouter = () => {
  const dispatch = useDispatch();

  const ProtectedRoute = ({ children }) => {
    const usr = JSON.parse(localStorage.getItem("iTestUser"));
    const [loading, setLoading] = React.useState(true);
    const { decodedToken, isExpired } = useJwt(usr?.accessToken);

    React.useEffect(() => {
      if (isExpired) {
        return <Navigate to="/login" />;
      } else {
        dispatch(login(usr));
        dispatch(add_test(JSON.parse(localStorage.getItem("iTest_test"))));
        setLoading(false);
      }
    }, [isExpired, usr, dispatch]);

    return loading ? (
      <Box sx={{ width: "100%", height: "100%", textAlign: "center", mt: 10 }}>
        <Typography sx={{ fontSize: 14, mb: 5 }}>Wait ...</Typography>
        <CircularProgress size={40} sx={{ color: "gold" }} />
      </Box>
    ) : (
      children
    );
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Sign />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/testInfo" element={
            <ProtectedRoute>
              <Layout>
                <TestInfo />
              </Layout>
            </ProtectedRoute>
          }/>
        <Route path="/createTrain" element={
            <ProtectedRoute>
              <Layout>
                <CreateTrain />
              </Layout>
            </ProtectedRoute>
          } />
        <Route path="/checkPart" element={
            <ProtectedRoute>
              <Layout>
                <TestReport />
              </Layout>
            </ProtectedRoute>
          }/>
        <Route path="/createTest" element={
            <ProtectedRoute>
              <Layout>
                <Add_test />
              </Layout>
            </ProtectedRoute>
          } />
        <Route path="/duplicateTest" element={
            <ProtectedRoute>
              <Layout>
                <DuplicateTest />
              </Layout>
            </ProtectedRoute>
          }/>
        <Route path="/editTest" element={
            <ProtectedRoute>
              <Layout>
                <EditTest />
              </Layout>
            </ProtectedRoute>
          }/>
        <Route path="/testReport" element={
            <ProtectedRoute>
              <Layout>
                <PartDetail />
              </Layout>
            </ProtectedRoute>
          }/>
        <Route path="/testDetail" element={
            <ProtectedRoute>
              <Layout>
                <TestDetail />
              </Layout>
            </ProtectedRoute>
          }/>
        <Route path="/template" element={
            <ProtectedRoute>
              <Layout>
                <Template />
              </Layout>
            </ProtectedRoute>
          }/>
        <Route path="/createTemplate" element={
            <ProtectedRoute>
              <Layout>
                <CreateTemplate />
              </Layout>
            </ProtectedRoute>
          } />
        <Route path="/templateInfo" element={
            <ProtectedRoute>
              <Layout>
                <TemplateInfo />
              </Layout>
            </ProtectedRoute>
          }/>
        <Route path="/assessmentInfo" element={
            <ProtectedRoute>
              <Layout>
                <AssessmentInfo />
              </Layout>
            </ProtectedRoute>
          } />
        <Route path="/duplicateTemplate" element={
            <ProtectedRoute>
              <Layout>
                <DuplicateTemplate />
              </Layout>
            </ProtectedRoute>
          } />
        <Route path="/editTemplate" element={
            <ProtectedRoute>
              <Layout>
                <EditTemplate />
              </Layout>
            </ProtectedRoute>
          } />
        <Route path="/addParticipant" element={
            <ProtectedRoute>
              <Layout>
                  <AddParticipant />
              </Layout>
            </ProtectedRoute>
          } />
        <Route path="/assessmentReport" element={
            <ProtectedRoute>
              <Layout>
                <CandidateDetail />
              </Layout>
            </ProtectedRoute>
          } />
        <Route path="/addJob" element={
            <ProtectedRoute>
              <Layout>
                <AddJob />
              </Layout>
            </ProtectedRoute>
          }/>
        <Route path="/profile" element={
            <ProtectedRoute>
              <Layout>
                <UserProfile />
              </Layout>
            </ProtectedRoute>
          }/>
        <Route path="/myTests" element={
            <ProtectedRoute>
              <Layout>
                <MyTests />
              </Layout>
            </ProtectedRoute>
          } />
        <Route path="/jobInfo" element={
            <ProtectedRoute>
              <Layout>
                <JobInfo />
              </Layout>
            </ProtectedRoute>
          } />
        <Route path="/jobReport" element={
            <ProtectedRoute>
              <Layout>
                <JobReport />
              </Layout>
            </ProtectedRoute>
          } />
        <Route path="/editJob" element={
            <ProtectedRoute>
              <Layout>
                <EditJob />
              </Layout>
            </ProtectedRoute>
          } />
        <Route path="/sendMail" element={
            <ProtectedRoute>
              <Layout>
                <SendMail />
              </Layout>
            </ProtectedRoute>
          } />
        <Route path="/candidate" element={
            <ProtectedRoute>
              <Layout>
                <CandidatePortal />
              </Layout>
            </ProtectedRoute>
          } />
        <Route path="/candidateDetail" element={
            <ProtectedRoute>
              <Layout>
                <CandidateTestPortal />
              </Layout>
            </ProtectedRoute>
          } />        
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Layout>
                  <Home />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route path="/jobs" element={<Jobs />} />
        <Route 
          path="/jobApplication" 
          element={<ProtectedRoute><JobApplication /></ProtectedRoute>} 
        />
        
        <Route path="/TakeOpenTest" element={<TakeOpenTest />} />
        
        <Route 
          path="/trainTest" 
          element={<ProtectedRoute><TrainTest /></ProtectedRoute>} 
        />
        
        <Route 
          path="/tryAssessment" 
          element={<ProtectedRoute><TryAssessment /></ProtectedRoute>} 
        />
        
        <Route 
          path="/takeAssessment" 
          element={<ProtectedRoute><TakeAssessment /></ProtectedRoute>} 
        />
        
        <Route 
          path="/tryTest" 
          element={<ProtectedRoute><TryTest /></ProtectedRoute>} 
        />
        
        <Route 
          path="/takeTest" 
          element={<ProtectedRoute><TakeTest /></ProtectedRoute>} 
        />
        
        <Route 
          path="/jobTest" 
          element={<ProtectedRoute><JobTest /></ProtectedRoute>} 
        />
        
        <Route 
          path="/myJobs" 
          element={<ProtectedRoute><MyJobs /></ProtectedRoute>} 
        />
        
        <Route path="/Job/:id" element={<Job />} />
        
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
